export default {
  "admin": "Администратор",
  "group_admin": "Администратор группы пользователей",
  "user": "Обычный пользователь",
}
